module.exports = __webpack_public_path__ + "6369794dca0602122bc13e866734811a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcb.png
// module id = 209
// module chunks = 1